/**
 * @generated SignedSource<<be9406e042814591ec1e62ed2c45e3d2>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView$data = {
  readonly confluenceRemoteIssueLinks: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly href: string | null | undefined;
        readonly pageContent?: {
          readonly href?: string | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
    readonly totalCount: number | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"popupContent_issueFieldConfluencePagesReadviewFull">;
  } | null | undefined;
  readonly " $fragmentType": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView";
};
export type confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView$key = {
  readonly " $data"?: confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView$data;
  readonly " $fragmentSpreads": FragmentRefs<"confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "href"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "confluencePages_issueFieldConfluencePagesReadviewFull_ConfluencePagesReadView",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 1000
        }
      ],
      "concreteType": "JiraConfluenceRemoteIssueLinkConnection",
      "kind": "LinkedField",
      "name": "confluenceRemoteIssueLinks",
      "plural": false,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "popupContent_issueFieldConfluencePagesReadviewFull"
        },
        {
          "kind": "ScalarField",
          "name": "totalCount"
        },
        {
          "concreteType": "JiraConfluenceRemoteIssueLinkEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraConfluenceRemoteIssueLink",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v0/*: any*/),
                {
                  "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiraconfluencepagecontentenabledrelayprovider",
                  "kind": "Condition",
                  "passingValue": true,
                  "selections": [
                    {
                      "kind": "LinkedField",
                      "name": "pageContent",
                      "plural": false,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            (v0/*: any*/)
                          ],
                          "type": "JiraConfluencePageContentDetails"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ],
      "storageKey": "confluenceRemoteIssueLinks(first:1000)"
    }
  ],
  "type": "JiraConfluenceRemoteIssueLinksField"
};
})();

(node as any).hash = "f3dfa170a3952ce8210f6278505d4948";

export default node;
